import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'

export default class Text extends React.Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    field: PropTypes.object
  }

  state = {}

  componentDidMount() {
    this.setState({text: this.props.value ? this.props.value.text : ''})
  }

  @autobind
  save() {
    this.props.onChange(this.state.text)
  }

  @autobind
  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.save()
      event.preventDefault()
    }
  }

  renderInformation() {
    let required = '(Opcional)'
    if (!this.props.field) return null
    if (this.props.field.required) {
      required = '(Requerido)'
    }
    if (this.props.field.name) {
      return `${this.props.field.name} ${required}`
    }
    if (this.props.field.validation) {
      return `${this.props.field.validation} ${required}`
    }
    return `Texto ${required}`
  }

  renderClassName(textSize) {

    let style = ''
    if (this.props.field.required) {
      style = styles.inputRequired
      if (textSize === 'medium') { style += ' ' + styles.medium } else if (textSize === 'large') { style += ' ' + styles.large }
    } else {
      style = styles.inputNoRequired
      if (textSize === 'medium') { style += ' ' + styles.medium } else if (textSize === 'large') { style += ' ' + styles.large }
    }
    console.log('Estilo calculado: ', style)
    return style
  }

  messageField() {
    if (this.props.field.required) {
      return 'Información Requerida'
    }
    return 'Información Opcional'
  }

  render() {
    return (
      <Tooltip content={this.messageField()}>
        <input
          type="text"
          onBlur={this.save}
          value={this.state.text}
          onKeyPress={this.handleKeyPress}
          placeholder={this.renderInformation()}
          className={this.renderClassName(this.props.field.textSize)}
          onChange={event => this.setState({text: event.target.value})}
          id={this.props.field.id}
          data-filled={this.props.value ? 'true' : 'false'}
          data-filler={this.props.field && this.props.field.filler}
          data-required={this.props.field && this.props.field.required ? 'true' : 'false'}
        />
      </Tooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/Field/Edit/Text/index.js